import { Admin, Resource, CustomRoutes, defaultTheme } from "react-admin";
import { Route, Navigate } from "react-router-dom";

import dataProvider from "./dataProvider";
import authProvider from "./authProvider";
import i18nProvider from "./i18nProvider";

import PeopleIcon from "@mui/icons-material/People";

import { SiteList, SiteCreate, SiteEdit } from "./sites";
import { MainLayout } from "./layout/Layout";
import { RemovalsListBySite } from "./site-inventory/RemovalsListBySite";
import { SitePreview } from "./sites/SitePreview";

import { ExternalCalendarPage } from "./externals/pages/ExternalCalendarPage";
import { ExternalEquipmentsPage } from "./externals/pages/ExternalEquipmentsPage";
import { ExternalStatsPage } from "./externals/pages/ExternalStatsPage";
import { ExternalDeclarationPage } from "./externals/pages/ExternalDeclarationPage";

import { ExternalLayout } from "./layout/ExternalLayout";
import { NotFoundPage } from "./NotFoundPage";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.locale("fr");

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
      <Admin
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        layout={MainLayout}
        theme={defaultTheme}
      >
        <CustomRoutes noLayout>
          <Route path="/externals" element={<ExternalLayout />}>
            <Route index element={<Navigate to="calendar" replace />} />

            <Route path="calendar" element={<ExternalCalendarPage />} />
            <Route path="equipments" element={<ExternalEquipmentsPage />} />
            <Route path="declarations" element={<ExternalDeclarationPage />} />
            <Route path="stats" element={<ExternalStatsPage />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </CustomRoutes>
        <Resource
          name="sites"
          options={{ label: "Sites" }}
          icon={PeopleIcon}
          list={SiteList}
          edit={SiteEdit}
          create={SiteCreate}
        />

        <CustomRoutes>
          <Route path="/sites/:id/preview" element={<SitePreview />} />
          <Route path="/sites/:id/stats" element={<RemovalsListBySite />} />
          <Route path="*" element={<NotFoundPage />} />
        </CustomRoutes>
      </Admin>
    </LocalizationProvider>
  );
}

export default App;
